var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogUserAction = function SvgLogUserAction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19319_35862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.44719 7.42571V4.47171C8.44719 3.92771 8.00652 3.48705 7.46252 3.48705C6.91852 3.48705 6.47786 3.92771 6.47786 4.47171V6.76904V10.1537L4.71386 9.24838C4.31252 9.04238 3.82386 9.11905 3.50519 9.43771C3.08319 9.85971 3.10319 10.5497 3.54852 10.947L6.76519 13.8157C7.00919 14.0337 7.32519 14.1537 7.65252 14.1537H10.7412C11.3659 14.1537 11.9072 13.7197 12.0425 13.1097L12.7579 9.88971C12.9665 8.94971 12.3379 8.02838 11.3865 7.88105L8.44719 7.42571V7.42571Z",
    stroke: "#D1D1D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4873 2.82037C6.10997 0.731039 8.7413 0.731039 10.364 2.82037",
    stroke: "#D1D1D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19319_35862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
export { SvgLogUserAction as ReactComponent };
export default __webpack_public_path__ + "log-user-action.svg";